import Dialog from '@components/Atoms/Dialog';
import Button from '@components/Atoms/Button';
import PreviewQuestion from '@learnosityassessment/Components/PreviewQuestion';
import React from 'react';
import ChalkTalkErrorBoundary from '@components/ChalkTalkErrorBoundary';
import LoadingIndicator from '@components/LoadingIndicator';
import Box from '@components/Atoms/Box';
import ShowIf from '@components/Atoms/ShowIf';

const QuestionPreview = ({ referenceId }) => {
  const [openDialog, setOpenDialog] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);

  return (
    <>
      <Button onClick={() => setOpenDialog(true)}>Preview</Button>
      <Dialog
        title="Question Preview"
        maxWidth="xl"
        fullWidth
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
        }}
        PaperProps={{
          sx: {
            minHeight: '600px',
            height: '80vh',
            display: 'flex',
            flexDirection: 'column',
            '& .MuiDialogContent-root': {
              flex: '1 1 auto',
              overflow: 'auto',
              padding: '20px',
            },
            '& .MuiDialogActions-root': {
              flex: '0 0 auto',
              padding: '16px',
              borderTop: '1px solid rgba(0, 0, 0, 0.12)',
              marginTop: 'auto',
            },
          },
        }}
        actions={[
          {
            label: 'Close',
            onClick: () => {
              setOpenDialog(false);
            },
            buttonProps: {
              variant: 'contained',
              sx: {
                minWidth: '100px',
              },
            },
          },
        ]}
      >
        <ChalkTalkErrorBoundary hideBackButton>
          <ShowIf If={isLoading}>
            <Box sx={{ height: '50%' }}>
              <LoadingIndicator content="Loading Preview..." height100 noBackground />
            </Box>
          </ShowIf>
          <PreviewQuestion
            referenceId={referenceId}
            widgetRef={null}
            eventHandlers={null}
            setIsLoading={setIsLoading}
          />
        </ChalkTalkErrorBoundary>
      </Dialog>
    </>
  );
};

export default QuestionPreview;
